import { render } from "./TabContent.vue?vue&type=template&id=9ec41dcc&scoped=true"
import script from "./TabContent.vue?vue&type=script&lang=js"
export * from "./TabContent.vue?vue&type=script&lang=js"

import "./TabContent.vue?vue&type=style&index=0&id=9ec41dcc&lang=scss&scoped=true"

import exportComponent from "/Users/huangli/Desktop/未命名文件夹 2/borun/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ec41dcc"]])

export default __exports__